import { render, staticRenderFns } from "./SecretaryForm.vue?vue&type=template&id=2367846a&scoped=true&"
import script from "./SecretaryForm.vue?vue&type=script&lang=js&"
export * from "./SecretaryForm.vue?vue&type=script&lang=js&"
import style0 from "./SecretaryForm.vue?vue&type=style&index=0&id=2367846a&scoped=true&lang=css&"
import style1 from "./SecretaryForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2367846a",
  null
  
)

export default component.exports